import { render, staticRenderFns } from "./ReportVictimDisasterGraphYear.vue?vue&type=template&id=52939fe2&scoped=true"
import script from "./ReportVictimDisasterGraphYear.vue?vue&type=script&lang=js"
export * from "./ReportVictimDisasterGraphYear.vue?vue&type=script&lang=js"
import style0 from "./ReportVictimDisasterGraphYear.vue?vue&type=style&index=0&id=52939fe2&prod&scoped=true&lang=css"
import style1 from "./ReportVictimDisasterGraphYear.vue?vue&type=style&index=1&id=52939fe2&prod&lang=css"
import style2 from "./ReportVictimDisasterGraphYear.vue?vue&type=style&index=2&id=52939fe2&prod&scoped=true&lang=scss"
import style3 from "./ReportVictimDisasterGraphYear.vue?vue&type=style&index=3&id=52939fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52939fe2",
  null
  
)

export default component.exports